//
//
//
//
//
//
//
//

import util from '@/common/js/util'

export default {
  name: 'App',
}



// WEBPACK FOOTER //
// ./src/App.vue